<template>
    <div>
        <div class="guest-logo">
            <img
                src="/images/logo.png"
                alt="goTenna Pro Management Portal"
            />
        </div>
        <p style="width: 500px; font-size: 14px; margin: 20px auto 60px auto; text-align: center; line-height: 22px">
            <strong>Welcome to goTenna!</strong> Complete the form below to complete your Management Portal
            Registration. The Management Portal will allow you to manage users and frequency sets, view the backhaul
            map, and more. We recommend using the contact information of the team member that will be managing the
            goTenna devices and users.<br /><br />If you have any questions, reach out to prosupport@goTenna.com.
        </p>
        <div class="module form-module">
            <section class="module__body">
                <form
                    class="full-width"
                    @submit.prevent="addAdmin"
                >
                    <div class="form-flex">
                        <div class="form-flex-group">
                            <div class="form-group">
                                <label for="name">Organization Name</label>
                                <input
                                    id="organization_name"
                                    v-model="organizationName"
                                    type="text"
                                    required
                                    maxlength="60"
                                />
                            </div>

                            <div class="form-group">
                                <label for="name">Name</label>
                                <input
                                    id="name"
                                    v-model="name"
                                    type="text"
                                    required
                                    maxlength="60"
                                />
                            </div>

                            <div class="form-group">
                                <label for="title">Title</label>
                                <input
                                    id="title"
                                    v-model="title"
                                    type="text"
                                    required
                                    maxlength="60"
                                />
                            </div>

                            <div class="form-group">
                                <label for="username">Username</label>
                                <input
                                    id="username"
                                    v-model="username"
                                    type="text"
                                    required
                                    maxlength="32"
                                />
                            </div>

                            <div class="form-group">
                                <label for="email">Email</label>
                                <input
                                    id="email"
                                    v-model="email"
                                    type="text"
                                    required
                                    maxlength="255"
                                />
                            </div>

                            <div class="form-group">
                                <label for="password">Password</label>
                                <input
                                    id="password"
                                    v-model="password"
                                    type="password"
                                    required
                                    maxlength="255"
                                />
                            </div>

                            <div class="form-group">
                                <label for="password_confirmation">Confirm Password</label>
                                <input
                                    id="password_confirmation"
                                    v-model="passwordConfirmation"
                                    type="password"
                                    required
                                    maxlength="255"
                                />
                            </div>
                        </div>
                    </div>

                    <form-errors :response="errorResponse" />

                    <div class="form-group">
                        <button
                            type="submit"
                            class="btn btn-primary"
                            :class="{ active: submitted }"
                        >
                            <div>Submit</div>
                        </button>
                    </div>
                </form>
            </section>
        </div>
    </div>
</template>

<script>
import FormErrors from '@/components/FormErrors.vue'
import canToast from '@/mixins/canToast'

export default {
    components: {
        FormErrors,
    },

    mixins: [canToast],

    props: {
        registrationToken: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            name: null,
            title: null,
            username: null,
            email: null,
            password: null,
            passwordConfirmation: null,
            errorResponse: null,
            organizationName: null,
            submitted: false,
        }
    },

    mounted() {},

    methods: {
        addAdmin() {
            this.submitted = true

            this.$http
                .post(`registration-tokens/${this.registrationToken.token}`, {
                    name: this.name,
                    title: this.title,
                    username: this.username,
                    email: this.email,
                    groups: this.usersGroups,
                    password: this.password,
                    password_confirmation: this.passwordConfirmation,
                    organization_name: this.organizationName,
                })
                .then(() => {
                    this.toast('User successfully added! An email will be sent to this user to confirm their account.')
                    this.$router.push({ name: 'login' })
                })
                .catch((error) => {
                    this.errorResponse = error.response
                    this.submitted = false
                })
        },
    },
}
</script>
